// extracted by mini-css-extract-plugin
export default {"emailSentText":"ResetPasswordSuccessScreen_emailSentText__MmfTR"};